import React, { FC } from 'react';
import { CustomButton } from '@mindly/ui-components';
import {
  CancelSubscriptionButton,
  SubscriptionActionModalText,
  SubscriptionActionModalTitle,
} from '../CancelSubscriptionModal.style';
import { FormattedMessage } from 'react-intl';

type FirstStepProps = {
  handleNextStep: () => void;
  handlePauseSubscription: () => void;
};

const FirstStep: FC<FirstStepProps> = ({ handleNextStep, handlePauseSubscription }) => {
  return (
    <div className={'first-step-wrapper'}>
      <SubscriptionActionModalTitle>
        <FormattedMessage id={'subscription.cancel.step.1.title'} defaultMessage={'Скасувати підписку?'} />
      </SubscriptionActionModalTitle>
      <SubscriptionActionModalText>
        <FormattedMessage
          id={'subscription.cancel.step.1.text'}
          defaultMessage={'Ви можете призупинити план, якщо Вам потрібна перерва.'}
        />
      </SubscriptionActionModalText>
      <CustomButton buttonType={'primary'} onClick={handlePauseSubscription} className={'first-step-btn'}>
        <FormattedMessage id={'subscription.set.pause.title'} defaultMessage={'Призупинити підписку'} />
      </CustomButton>
      <CancelSubscriptionButton onClick={handleNextStep}>
        <FormattedMessage id={'general.cancel.btn'} defaultMessage={'Скасувати'} />
      </CancelSubscriptionButton>
    </div>
  );
};

export default FirstStep;
